import { AfterContentInit, AfterViewInit, ChangeDetectionStrategy, Component, inject, Input, input, OnInit, signal } from '@angular/core';
import { EmailListService } from '../../services/email-list.service';
import { CommonModule, NgForOf } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';

import {COMMA, ENTER} from '@angular/cdk/keycodes';


import {MatChipEditedEvent, MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { LiveAnnouncer } from '@angular/cdk/a11y';

import { Signal } from '@angular/core';
import { AlertListService } from '../../services/alert-list.service';


@Component({
    selector: 'app-rekbot-settings-email-list',
    standalone: true,
    imports: [
        //NgForOf,
        MatInputModule,
        CommonModule,
        FormsModule,
        MatCardModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule
    ],
    templateUrl: './rekbot-settings-email-list.component.html',
    styleUrl: './rekbot-settings-email-list.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RekbotSettingsEmailListComponent implements OnInit {

  @Input() settingsEmailList: Signal<string> = signal("") ;
  @Input() emailService?: EmailListService | AlertListService = new EmailListService();
  @Input() type?: string = "";

  readonly announcer = inject(LiveAnnouncer);

  readonly addOnBlur = false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  readonly emails = signal<string[]>([]);

  public newEmail: string = '';

  constructor(
  ) {
  }

  ngOnInit(): void {
    setTimeout( () => {
      // console.log("timeouted", this.emailService?.getEmail())
      const mailsStr = this.emailService?.getEmail();

        if(mailsStr?.length) {
          let mails = mailsStr.split(";");
          mails.forEach((item) => this.insertEmail(item));
          }

    }, 2000)
  }

  addEmail() {
    this.emailService?.addEmail(this.newEmail);
    this.newEmail = '';
  }

  removeEmail(email: string) {
    this.emailService?.removeEmail(email);
  }

  insertEmail(value: string) {

    if (value) {
      this.emails.update(emails => [...emails, value]);
    }
  }

  add(event: MatChipInputEvent): void {

    const value = (event.value || '').trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if(value && !emailRegex.test(value)) {
      alert("Popraw adres email");
      return;
    }

    // Add next email
    if (value) {
      this.insertEmail(value);
      //this.emails.update(emails => [...emails, value]);
      this.emailService?.addEmail(value);
    }

    // Clear the input value
    event.chipInput!.clear();
  }

  remove(email: string): void {
    this.emails.update(emails => {
      const index = emails.indexOf(email);
      if (index < 0) {
        return emails;
      }

      emails.splice(index, 1);
      this.emailService?.removeEmail(email);

      this.announcer.announce(`Removed ${email}`);
      return [...emails];
    });
  }  

  edit(email: string, event: MatChipEditedEvent) {
    const value = event.value.trim();

    // Remove email if it no longer has a name
    if (!value) {
      this.remove(email);
      return;
    }

    // Edit existing fruit
    this.emails.update(emails => {
      const index = emails.indexOf(email);
      if (index >= 0) {
        emails[index] = value;
        return [...emails];
      }
      return emails;
    });

  }  

}
